import { Injectable } from '@angular/core';
import { NumberSensorInputMap } from '../models/device';

@Injectable({
    providedIn: 'root'
})
export class InputMapService {
    public static $name = 'inputMapService';
    public static instance: InputMapService;

    private _numberInputMappings: { [id: string]: NumberSensorInputMap } = {};

    constructor() {
        InputMapService.instance = this;
        this.addNumberInputMappings();
    }

    public getNumberInputMapping(inputType: string) {
        return this._numberInputMappings[inputType];
    }

    /**
     * This is for all input types that are a number input.  Instead of having a
     * zillion directives, controllers, and views the following contains the
     * input specific metadata.
     */
    private addNumberInputMappings() {
        this.addNumberInputMapping('AirQualitySensor', '', '0.1');
        this.addNumberInputMapping('ConcentrationSensor', '', '0.1');
        this.addNumberInputMapping('CountSensor', '', '1');
        this.addNumberInputMapping('ElectricalCurrentSensor', 'A', '0.1');
        this.addNumberInputMapping('ElectricalPotentialSensor', 'V', '0.1');
        this.addNumberInputMapping('EnergySensor', '', '0.1');
        this.addNumberInputMapping('FloatingCountSensor', '', '0.1');
        this.addNumberInputMapping('FrequencySensor', 'Hz', '0.1');
        this.addNumberInputMapping('MinutesSensor', 'min', '1');
        this.addNumberInputMapping('PercentageSensor', '%', '0.1');
        this.addNumberInputMapping('PortSensor', '', '1');
        this.addNumberInputMapping('PowerSensor', '%', '0.1');
        this.addNumberInputMapping('PressurePsiSensor', 'PSI', '0.1');
        this.addNumberInputMapping('PressureSensor', 'in. w.c.', '0.1', '0.001');
        this.addNumberInputMapping('RelativeHumiditySensor', '%', '0.1');
        this.addNumberInputMapping('SpeedSensor', '', '0.1');
        this.addNumberInputMapping('TemperatureDifferentialSensor', '°', '0.1');
        this.addNumberInputMapping('TemperatureSensor', '°', '0.1');
        this.addNumberInputMapping('TimeZoneSensor', '', '1');
        this.addNumberInputMapping('VersionSensor', '', '0.1');
        this.addNumberInputMapping('VolumetricFlowSensor', '', '0.1');
        this.addNumberInputMapping('OverrideMinutesSensor', '', '30');
        this.addNumberInputMapping('PressureKpaSensor', '', '0.1');
    }

    private addNumberInputMapping(inputType: string, units: string, step: string, ngStep: string = '0.01') {
        this._numberInputMappings[inputType] = {
            inputType: 'NumberSensor',
            units: units,
            step: step,
            ngStep: ngStep
        };
    }
}
